// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1Y75O","gfeWrapper":"CalendarEvent_gfeWrapper__pcRoA"};